import React from 'react';
import PropTypes from 'prop-types';

import './ExperienceBranding.scss';

// Small badge on a saved Experience's map page -- only rendered when the Experience has a logo_url.
const ExperienceBranding = ({ logoUrl, name }) => (
  <div className="experience-branding">
    <img src={logoUrl} alt={name} className="experience-branding-logo" />
    <span className="experience-branding-divider">&middot;</span>
    <span className="experience-branding-text">Powered by Seagull</span>
  </div>
);

ExperienceBranding.propTypes = {
  logoUrl: PropTypes.string.isRequired,
  name: PropTypes.string,
};

ExperienceBranding.defaultProps = {
  name: '',
};

export default ExperienceBranding;
